import { Helmet } from 'react-helmet-async';
import Competitors from 'src/sections/overview/dashboards/views/non-branded/views/competitors';

export default function NonBrandedVisibility() {
  return (
    <>
      <Helmet>
        <title>Visibility</title>
      </Helmet>

      <Competitors />
    </>
  );
}
